/**
 * @constructor
 * @param {import("../view-services/provider-account-view-model.service").ProviderAccountViewModelService} ProviderAccountViewModelService
 */
export function ArchivedAccountListController(
  ProviderAccountViewModelService,
) {
  ///- BINDINGS -///
  /** @type {import("core-services/provider-accounts.service").ArchivedProviderAccount[]} */
  this.providerAccounts = [];
  /** @type {ArchivedAccountList.Features} */
  this.features = {};
  /** @type {ArchivedAccountList.OnRemoveAccountFn} */
  this.onRemoveAccount = async () => null;
  /** @type {ArchivedAccountList.OnRenameAccountFn} */
  this.onRenameAccount = async () => null;
  /** @type {ArchivedAccountList.OnReconnectProviderAccountFn} */
  this.onReconnectProviderAccount = async () => null;

  ///- END BINDINGS -///

  /** @type {import("../../../types").ProviderAccountWithArchivesVM[]} */
  this.providerAccountVMs = [];
  this.isShowRelinkAccountsEnabled = false;
  this.isCollapsed = true;
  this.toggleCollapseClick = () => {
    this.isCollapsed = !this.isCollapsed;
  };

  /**
   * @param {import("../../../types").ProviderAccountViewModel.AccountViewModel} accountVM
   * @param {string} name
   */
  this.accountWasRenamed = function(accountVM, name) {
    return this.onRenameAccount({ account: accountVM['@presenting'], name: name });
  };

  /**
   * @param {import("../../../types").ProviderAccountViewModel.AccountViewModel} accountVM
   */
  this.removeAccount = function(accountVM) {
    return this.onRemoveAccount({ account: accountVM['@presenting'] });
  };

  /**
   * @param {import("../../../types").ProviderAccountViewModel} providerAccountVM
   * @param {MouseEvent} $event
   */
  this.reconnectWasClicked = function(providerAccountVM, $event) {
    $event.preventDefault();
    return this.onReconnectProviderAccount({ providerAccount: providerAccountVM['@presenting'] });
  };


  /**
   * @this {ArchivedAccountListController}
   * @return {void}
   */
  this._updateViewModels = () => {
    this.providerAccountVMs =
      ProviderAccountViewModelService.buildModelsWithArchives(this.providerAccounts);
  };

  this._updateFeatures = () => {
    this.isShowRelinkAccountsEnabled =
      (this.features && this.features.showRelinkAccounts == true);
  }

  this.$onInit = function() {
    this._updateViewModels();
    this._updateFeatures();
  };

  this.$onChanges = function(changes) {
    if (changes.providerAccounts)
      this._updateViewModels();

    if (changes.features)
      this._updateFeatures();
  };
}

// @ts-ignore
import html from './archived-account-list.template.html';

export default {
  template: html,
  bindings: {
    providerAccounts: "<",
    features: "<",
    onRenameAccount: "&",
    onRemoveAccount: "&",
    onReconnectProviderAccount: "&"
  },
  controller: ArchivedAccountListController,
};

/**
 * @callback ArchivedAccountList.OnRenameAccountFn
 * @param {{ account: import("../../../types/api").AccountFromAPI, name: string }} options
 * @return {Promise<unknown>}
 */

/**
 * @callback ArchivedAccountList.OnRemoveAccountFn
 * @param {{ account: import("../../../types/api").AccountFromAPI }} options
 * @return {Promise<unknown>}
 */

/**
 * @callback ArchivedAccountList.OnReconnectProviderAccountFn
 * @param {{
  *    providerAccount: import("../../../types/api").ProviderAccountFromAPI,
  * }} options
  * @return {Promise<unknown>}
  */

 /**
  * @typedef {object} ArchivedAccountList.Features
  * @property {boolean} [showRelinkAccounts]
  */